import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconPlayCircleProps } from './IconPlayCircle.types'
import * as Styled from './styles/IconPlayCircle.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPlayCircle: FC<IconPlayCircleProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPlayCircleProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconPlayCircleProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M8.5 6.965v10.027a.876.876 0 0 0 .824.883c.2.008.395-.055.551-.176l.125-.09 6.441-4.77.192-.14a.844.844 0 0 0 .379-.699.845.845 0 0 0-.38-.703l-.183-.137-6.422-4.75c-.27-.219-.601-.375-.988-.207a.913.913 0 0 0-.539.832v.07'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M21.5 12c0 5.246-4.254 9.5-9.5 9.5S2.5 17.246 2.5 12 6.754 2.5 12 2.5s9.5 4.254 9.5 9.5Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconPlayCircle
